module.exports = __webpack_public_path__ + "img/optionchain3.e0d2a6d5.png";